interface LogoMarkProps {
  className?: string
}

/**
 * مونوگرام الونا — نسخهٔ جدید:
 * حرف E از سه ضربهٔ افقیِ قلم‌موی لاک روی یک ساقه ساخته شده و
 * قطرهٔ لاکِ طلایی، ادامهٔ ضربهٔ میانی است — امضای کارِ براش و لاک.
 * داخل نشانِ گوشه‌گردِ شبنشینی نشسته؛ وکتور خالص و قابل بازکردن در Illustrator.
 */
const LogoMark = ({ className = 'h-6 w-6' }: LogoMarkProps) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="elona-badge" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#4a2430" />
        <stop offset="1" stopColor="#241318" />
      </linearGradient>
    </defs>

    {/* نشان گوشه‌گرد */}
    <rect width="64" height="64" rx="17" fill="url(#elona-badge)" />

    {/* حرف E — ضربه‌های قلم‌مو */}
    <g fill="#f6e7d4">
      <rect x="16" y="15" width="6.5" height="34" rx="3.25" />
      <rect x="16" y="15" width="31" height="6.5" rx="3.25" />
      <rect x="16" y="28.75" width="19" height="6.5" rx="3.25" />
      <rect x="16" y="42.5" width="31" height="6.5" rx="3.25" />
    </g>

    {/* قطرهٔ لاک — پایان ضربهٔ میانی */}
    <circle cx="43.5" cy="32" r="3.75" fill="#e9c261" />
  </svg>
)

export default LogoMark
